/**
 * Created by yangyue on 2017/9/1.
 */

module.exports = {
  API_SERVER: 'http://127.0.0.1:2019',
  MASTER_WEB_URL: 'http://authtest.yukehulian.com',
  TOOLS_ID: '20',
  HOST: window.location.origin
}



// WEBPACK FOOTER //
// ./src/configs/dev.js